module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAu0lEQVQ4T52SgQ3CMAwEr5MAkwCTQCehTAJMAmzCJqCr7MhUSKitFDVpevn3xx0Ln24hxxTcARfgBTzj0FW8XV9TqIJH4ATsA6xmcu+ccAXf8OVgHaTqPulm4yJBT/THocg4F2r2Yn/8luAd0MbjD6jAFugr2IeCSodwkDZvoaZd9xpokl+pVVvFhaBjmFtjE6ipWqeWahjTKxnrq6nWuNtdFcpQVGtC087xSmwC6zBh1w7no9KvzpnVth8/iy4P+Bz0ZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus-zoom.png
// module id = dNBJ
// module chunks = 2